document.addEventListener('DOMContentLoaded', (e) => {
  e.preventDefault();

  // Sticky-header scroll state. Toggles .is-scrolled past the offset the
  // section sets, which is what swaps the logo and its size.
  const headerEl = document.querySelector('[data-header]');
  if (headerEl) {
    const offset = parseInt(headerEl.dataset.scrollOffset, 10) || 0;
    let ticking = false;

    const syncScrollState = () => {
      headerEl.classList.toggle('is-scrolled', window.scrollY > offset);
      ticking = false;
    };

    syncScrollState();
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncScrollState);
    }, { passive: true });
  }

  const navItems = document.querySelectorAll('[js-nav-item]');
  const navDropdowns = document.querySelectorAll('[js-nav-dropdown]');
  const menuBtn = document.querySelector('[js-menu-btn]');
  const mobileMenu = document.querySelector('[js-mob-menu]');
  const searchBtn = document.querySelector('.mobile-navigation .search-btn button');
  const backBtn = document.querySelector('[js-mobile-back-btn]');
  const mobileEls = document.querySelectorAll('[js-mobile-item]')

  let navId = '';
  let previousBodyOverflow = '';
  let previousHtmlOverflow = '';
  let isScrollLocked = false;

  function lockPageScroll() {
    if (isScrollLocked) return;

    previousBodyOverflow = document.body.style.overflow;
    previousHtmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    isScrollLocked = true;
  }

  function unlockPageScroll() {
    if (!isScrollLocked) return;

    document.body.style.overflow = previousBodyOverflow;
    document.documentElement.style.overflow = previousHtmlOverflow;
    isScrollLocked = false;
  }

  navItems.forEach(link => {
    link.addEventListener('mouseover', () => {
      const id = link.getAttribute('data-id');
      navItems.forEach(item => {
        item.classList.remove('active');
      });

      link.classList.add('active');
      navId = id;

      navDropdowns.forEach(rm => {
        rm.classList.add('hidden');
      });
      
      navDropdowns.forEach(dropContent => {
        const contentId = dropContent.getAttribute('data-id');
        if (id === contentId) {
          dropContent.classList.remove('hidden');
        }
      });
    })

    link.addEventListener('mouseleave', (e) => {
      setTimeout(() => {
        if (link.getAttribute('data-id') != navId) {
          link.classList.remove('active');
        }

        navDropdowns.forEach(dropContent => {
          if (dropContent.getAttribute('data-id') != navId) {
            dropContent.classList.add('hidden');
          }
        });
      }, 500);
    })
  });

  navDropdowns.forEach(dropdown => {
    dropdown.addEventListener('mouseover', (e) => {
      if (navId === dropdown.getAttribute('data-id')) {
        dropdown.classList.remove('hidden');
        navId = dropdown.getAttribute('data-id');
      }
    });
    
    dropdown.addEventListener('mouseleave', (e) => {
      if (!dropdown.classList.contains('hidden')) {
        dropdown.classList.add('hidden');
        navId = '';
      }
    });
  });


  // Predictive search for the header (desktop panel and mobile menu).
  // limit_scope=each gives products and articles their own limit; with the
  // default ("all") the limit was shared, so a few articles crowded products out.
  // 10 is the most Shopify's predictive search returns per type.
  const SEARCH_PRODUCT_LIMIT = 10;
  const SEARCH_ARTICLE_LIMIT = 3;
  let searchRequest = 0;
  let searchTimer;

  const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));

  // Every product shows its size (sizes are separate products, e.g. a 30ml and
  // a 50ml "Neo-Hydro Intensive Face Mask"). The size sits at the end of the
  // handle; articles have no size there, so they are listed as they are.
  const sizeFromHandle = (handle) => {
    const match = /-(\d+)-?ml$/i.exec(handle || '');
    return match ? `${match[1]}ml` : '';
  };

  const resultItems = (items) => items.map(item => {
    const size = sizeFromHandle(item.handle);
    const label = size ? `${item.title} · ${size}` : item.title;
    return `<li><a href="${escapeHtml(item.url)}">${escapeHtml(label)}</a></li>`;
  }).join('');

  function runSearch(query) {
    const id = ++searchRequest;
    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'product,article',
      'resources[limit]': String(SEARCH_PRODUCT_LIMIT),
      'resources[limit_scope]': 'each'
    });
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(`${root}search/suggest.json?${params}`)
      .then(res => res.json())
      .then(data => {
        // Typing fires a request per keystroke; only the latest may render.
        if (id !== searchRequest) return;
        const results = (data.resources && data.resources.results) || {};
        const products = resultItems(results.products || []);
        const articles = resultItems((results.articles || []).slice(0, SEARCH_ARTICLE_LIMIT));

        [['#product-results ul', products], ['#product-results-mobile ul', products],
         ['#article-results ul', articles], ['#article-results-mobile ul', articles]]
          .forEach(([selector, html]) => {
            const list = document.querySelector(selector);
            if (list) list.innerHTML = html;
          });
      })
      .catch(() => {});
  }

  function onSearchInput(resultBoxId, otherOptionId) {
    return function () {
      const query = this.value.trim();
      const resultBox = document.getElementById(resultBoxId);
      const otherOption = otherOptionId && document.getElementById(otherOptionId);
      clearTimeout(searchTimer);

      if (query.length < 2) {
        searchRequest++;
        if (resultBox) resultBox.classList.add('hidden');
        if (otherOption) otherOption.classList.remove('hidden');
        return;
      }

      if (otherOption) otherOption.classList.add('hidden');
      if (resultBox) resultBox.classList.remove('hidden');
      searchTimer = setTimeout(() => runSearch(query), 150);
    };
  }

  const searchInput = document.getElementById('search-input');
  const searchInputMobile = document.getElementById('search-input-mobile');
  if (searchInput) searchInput.addEventListener('input', onSearchInput('search-results'));
  if (searchInputMobile) searchInputMobile.addEventListener('input', onSearchInput('search-results-mobile', 'search-box-option-mobile'));

  if (menuBtn) {
    menuBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (mobileMenu) {
        const opening = !mobileMenu.classList.contains('active');
        mobileMenu.classList.toggle('active', opening);
        // The drawer is a later sibling, so CSS cannot reach back to the
        // button — the state is mirrored onto the button itself.
        menuBtn.classList.toggle('is-open', opening);
        menuBtn.setAttribute('aria-expanded', opening ? 'true' : 'false');
        menuBtn.setAttribute('aria-label', opening ? 'Close menu' : 'Menu');
        if (opening) lockPageScroll(); else unlockPageScroll();
      }
    })
  }

  if(searchBtn) {
    searchBtn.addEventListener('click', (e) => {
      e.preventDefault();
      mobileEls.forEach(element => {
        if (element.classList.contains('first_nav')) {
          element.classList.add('hidden');
        } else if(element.classList.contains('second_nav')) {
          element.classList.remove('hidden');
        }
      });
    });
  }

  if (backBtn) {
    backBtn.addEventListener('click', (e) => {
      e.preventDefault();

      mobileEls.forEach(element => {
        if (element.classList.contains('first_nav')) {
          element.classList.remove('hidden');
        } else if(element.classList.contains('second_nav')) {
          element.classList.add('hidden');
        }
      });
    })
  }
})

/*
 * Header app blocks (the Orbe Country Selector) are rendered once, in the
 * desktop menu, and moved into the mobile drawer on phone widths. Rendering
 * them twice duplicated the app's element IDs, and since the app binds its
 * controls by ID, both copies' handlers landed on one button (each click opened
 * and closed it) while the other copy got none. Moving the node keeps the
 * app's listeners attached.
 */
// Leading semicolon: the code above ends in `})` without one.
;(function () {
  function placeHeaderAppBlocks() {
    var content = document.querySelector('[data-app-slot-content]');
    var desktop = document.querySelector('[data-app-slot="desktop"]');
    var drawer = document.querySelector('[data-app-slot="drawer"]');
    if (!content || !desktop || !drawer) return;

    var mobile = window.matchMedia('(max-width: 767px)');
    var place = function () {
      var target = mobile.matches ? drawer : desktop;
      if (content.parentNode !== target) target.appendChild(content);
    };
    place();
    if (mobile.addEventListener) mobile.addEventListener('change', place);
    else if (mobile.addListener) mobile.addListener(place);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeHeaderAppBlocks);
  else placeHeaderAppBlocks();
})();
